export const CLIENT_TYPES = {
  CURRENT_CLIENT: "current_client",
  NEW_CLIENT: "new_client",
  PROSPECT_CLIENT: "prospect_client",
};

export const CLIENT_FORM = {
  CLIENT_ID: "clientId",
  CLIENT_TYPE: "clientType",
  BROKER_HAS_MULTIPLE_STRATEGIC_TIERS: "brokerHasMultipleStrategicTiers",
  NAME: "name",
  TOTAL_BENEFITS: "numberOfEmployees",
  CLIENT_SINCE: "clientSince",
  SIC: "sic",
  CITY: "city",
  STATE: "state",
  SITUS_STATE: "situsState",
  ZIP_CODE: "zipCode",
  STREET_1: "addressLine1",
  STREET_2: "addressLine2",
  PRODUCER_NAME: "producer",
  PRODUCER_FIRST_NAME: "producerFirstName",
  PRODUCER_LAST_NAME: "producerLastName",
  PRODUCER_EMAIL: "producerEmail",
  CLIENT_EXECUTIVE: "clientExecutive",
  PRACTICE: "practice",
  CORPORATE_ENTITY: "corporateEntity",
  OFFICE: "officeLocation",
  BROKER_TYPE: "brokerType",
  ONEDIGITAL_OFFICE: "onedigitalOffice",
};

export const CLIENT_REDUCER_ACTIONS = {
  UPDATE_CLIENT: "updateClient",
  UPDATE_CLIENT_FIELD: "updateClientField",
  CLEAN_CLIENT: "cleanClient",
};

export const ONE_DIGITAL = "OneDigital";
export const MARKET = "market";

export const IS_CLIENT_FORM_VALID = "isClientFormValid";

export const CUSTOM_CONF_FIELDS = "customConfFields";

export const DEFAULT_CLIENT_SINCE = "1/1/1900";

export const PROSPECT_TYPE = "prospect";
